import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { AppProviders } from '@/app/providers/AppProviders'
import '@/styles/global.scss'
import { preventInstallOnPublicPages } from '@/app/publicPages/publicPages'

// Before anything renders, so Chrome never sees a ticket page as installable.
preventInstallOnPublicPages()

const root = document.getElementById('root')
if (!root) throw new Error('Application root element is missing.')

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
)
